<div *ngIf="id" class="analytics" fxLayout="row" fxLayout.lt-md="column">
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <chart
      title="Totals"
      [subtitle]="true"
      [type]="'line'"
      [data]="totalsChartData"
      [labels]="totalsChartLabels"
      [colors]="totalsChartColors"
      [loading]="totalsChartLoading"
      [labelFormatter]="totalsLabelFormatter"
      [isDarkMode]="isDarkMode">
        Hourly <strong>{{ productSku }}</strong> view totals for the past 24 hours
    </chart>
  </div>
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <chart
      title="Views"
      [subtitle]="true"
      [type]="'bar'"
      [data]="viewsChartData"
      [labels]="viewsChartLabels"
      [colors]="viewsChartColors"
      [loading]="viewsChartLoading"
      [labelFormatter]="viewsLabelFormatter"
      [isDarkMode]="isDarkMode">
        Most popular rooms to feature <strong>{{ productSku }}</strong> in the past 24 hours
    </chart>
  </div>
</div>
<div fxLayout="row" fxLayout.lt-md="column">
  <mat-card [fxFlex.gt-sm]="!isAddMode ? 50 : 100" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card-content>
      <form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="basic-form">
        <div fxLayout="row wrap" fxFlexAlign="center" class="row">
          <mat-form-field fxFlex="100" class="p-10">
            <mat-label>Description</mat-label>
            <input type="text" matInput formControlName="description" placeholder="Product Description">
            <mat-error *ngIf="form.description.hasError('required')">
              Description is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-lg="50" fxFlex="100" class="p-10">
            <mat-label>SKU</mat-label>
            <input type="text" matInput formControlName="sku" placeholder="sku-001">
            <mat-error *ngIf="form.sku.hasError('required')">
              SKU is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex.gt-lg="50" fxFlex="100" class="p-10">
            <mat-label>Display SKU</mat-label>
            <input type="text" matInput formControlName="displaySku" placeholder="SKU-001">
            <mat-error *ngIf="form.displaySku.hasError('required')">
              Display SKU is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <div class="mat-form-field p-10">
            <mat-slide-toggle formControlName="hideSku">Hide SKU</mat-slide-toggle>
          </div>
          <mat-form-field fxFlex.gt-lg="50" fxFlex="100" class="p-10">
            <mat-label>Type</mat-label>
            <input type="text" matInput formControlName="type">
          </mat-form-field>
          <mat-form-field fxFlex.gt-lg="50" fxFlex="100" class="p-10">
            <mat-label>Disabled</mat-label>
            <mat-select formControlName="disabled">
              <mat-option [value]="false">No</mat-option>
              <mat-option [value]="true">Yes</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex.gt-lg="50" fxFlex="100" class="p-10">
            <mat-label>Brand</mat-label>
            <input type="text" matInput formControlName="brand">
          </mat-form-field>
          <mat-form-field fxFlex.gt-lg="50" fxFlex="100" class="p-10">
            <mat-label>Brand Logo URL</mat-label>
            <input type="text" matInput formControlName="brandLogoUrl" placeholder="https://logourl.com">
          </mat-form-field>
          <div class="mat-form-field p-10">
            <mat-slide-toggle formControlName="showBrandLogoOnly">Hide Company Logo</mat-slide-toggle>
          </div>
        </div>
        <div fxLayoutAlign="end center" fxLayoutGap="15px">
          <button type="submit" class="add-action-button" mat-flat-button color="primary"
            [disabled]="!productForm.valid">
            <mat-icon>done</mat-icon> Save
          </button>
          <button type="button" class="reset-button" mat-stroked-button color="basic" (click)="showProductsView()">
            <mat-icon>clear</mat-icon> Cancel
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="!isAddMode" fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <div *ngIf="artifactsLoading">
      <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
    </div>
    <mat-card-content>
      <product-card [item]="product" [readonly]="true"></product-card>
      <mat-card *ngIf="product?.callerReferenceKey"
        class="contrast"
        [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row wrap" fxLayout.lt-sm="column">
          <div fxFlex="60" fxLayoutAlign="start center" fxLayout="row">
            <strong class="highlight" [ngClass.lt-sm]="{'card-title': true}">{{ getProduct(product.callerReferenceKey) }}</strong>
          </div>
          <div fxFlex="40" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
            <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
              <button
                mat-icon-button color="basic"
                matTooltip="Remove Match"
                aria-label="Remove Match"
                (click)="onClickProductArtifact('')">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
          <small fxFlex="100">{{ product.callerReferenceKey }}</small>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="!product?.callerReferenceKey" class="contrast" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <mat-form-field>
            <input matInput type="text"
                [formControl]="searchArtifactField"
                (keyup)="doFilterArtifacts($event.target.value)"
                (keyup.esc)="$event.target.value=''; doFilterArtifacts('')"
                placeholder="Search product artifacts by name">
            </mat-form-field>
        </mat-card-content>
      </mat-card>
      <ng-container *ngIf="!product?.callerReferenceKey">
        <mat-card class="contrast card-link" *ngFor="let item of filteredProductArtifacts"
          [ngClass.lt-sm]="{'mat-card-inline-sm': true}"
          (click)="onClickProductArtifact(item?.callerReferenceKey)">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="60" fxLayoutAlign="start center" fxLayout="row">
              <strong [matTooltip]="item.isProduct ? 'Product' : 'Material'" [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item.name | highlight: searchArtifactField.value"></strong>
              <small class="m-l-5">v<span class="text-success">{{ item.version }}</span></small>
            </div>
            <div fxFlex="40" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
              <mat-icon *ngIf="item.isProduct" [matTooltip]="item.isProduct ? 'Product' : 'Material'">kitchen</mat-icon>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </mat-card-content>
  </mat-card>
  <!-- FOR PORTAL-1274 -->
  <!-- <mat-card *ngIf="id" fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <div *ngIf="showLoading">
      <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
    </div>
    <mat-card-content>
      <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
        <label>Product Featured in |
          <span *ngIf="isNotHomeFeed" class="text-warning ifc-link" (click)="toggleHomeFeed()">Show Homes</span>
          <span *ngIf="!isNotHomeFeed" class="text-success ifc-link" (click)="toggleHomeFeed()">Show Themes</span>
        </label>
      </div>
      <ng-container *ngIf="isNotHomeFeed">
        <div>
          <mat-card class="contrast" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="25" fxLayoutAlign="start center" fxLayout="row">
                <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}">Bohemian</strong>
              </div>
              <div fxFlex="75" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="18px">
                <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                  <p><small>bohemian is in </small></p>
                  <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">
                    <span class="text-info">4</span>
                  </div>
                  <p>&nbsp;<small>homes</small></p>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>
      <ng-container *ngIf="!isNotHomeFeed">
        <div>
          <mat-card class="contrast" [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="25" fxLayoutAlign="start center" fxLayout="row">
                <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}">Chatfield 178</strong>
              </div>
              <div fxFlex="75" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="18px">
                <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                  <p><small>options</small></p>
                  <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">
                    <span class="text-info">ENS-1</span>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card> -->
</div>
